export const getDocumento = pessoa => {
  if (!pessoa) return ''

  if (pessoa?.pessoaFisica) {
    return pessoa.pessoaFisica.cpf
  }

  if (pessoa?.pessoaJuridica) {
    return pessoa.pessoaJuridica.cnpj
  }

  return ''
}

export const getNomePessoa = pessoa => {
  if (!pessoa) return ''

  if (pessoa?.pessoaFisica) {
    return pessoa.pessoaFisica.nome
  }
  if (pessoa?.pessoaJuridica) {
    return pessoa.pessoaJuridica.nomeFantasia
  }
  return ''
}
